import styled from 'styled-components';
import React from 'react';
import { OptionTypeBase } from 'react-select';
import { IndicatorComponentType } from 'react-select/src/components';
import { typography } from '@clds/typography';
import { comboboxTheme } from '../theme';

const Root = styled.div`
  ${typography.xxs.lowContrast};
  display: flex;
  align-items: center;
  padding: ${comboboxTheme.groupHeading.padding.vertical} ${comboboxTheme.groupHeading.padding.horizontal};
`;

export const GroupHeading: IndicatorComponentType<OptionTypeBase> = ({ children, ...restProps }) => (
  <Root {...restProps}>
    {children}
  </Root>
);
